import { lazy } from 'react';

export const AuthBridge = lazy(() =>
  import('Modules/AuthBridge').then((module) => ({
    default: module.AuthBridge,
  })),
);
export const ActivitiesLobby = lazy(() =>
  import('Modules/ActivitiesLobby').then((module) => ({
    default: module.ActivitiesLobby,
  })),
);
export const Home = lazy(() =>
  import('Modules/Home').then((module) => ({ default: module.Home })),
);
export const MedicationsAndPrescriptionsLobby = lazy(() =>
  import('Modules/MedicationsAndPrescriptionsLobby').then((module) => ({
    default: module.MedicationsAndPrescriptionsLobby,
  })),
);
export const MedicationHistory = lazy(() =>
  import('Modules/MedicationHistory').then((module) => ({
    default: module.MedicationHistory,
  })),
);
export const ExpiredMedicationsLobby = lazy(() =>
  import('Modules/ExpiredMedicationsLobby').then((module) => ({
    default: module.ExpiredMedicationsLobby,
  })),
);
export const MedicineOrderInfo = lazy(() =>
  import('Modules/MedicineOrderInfo').then((module) => ({
    default: module.MedicineOrderInfo,
  })),
);
export const Status = lazy(() =>
  import('Modules/Status').then((module) => ({ default: module.Status })),
);
export const SingleStatus = lazy(() =>
  import('Modules/SingleStatus').then((module) => ({
    default: module.SingleStatus,
  })),
);
export const Paychecks = lazy(() =>
  import('Modules/Paychecks').then((module) => ({ default: module.Paychecks })),
);
export const AppliesLobby = lazy(() =>
  import('Modules/AppliesLobby').then((module) => ({
    default: module.AppliesLobby,
  })),
);
export const IframeAppliesLobby = lazy(() =>
  import('Modules/AppliesLobby').then((module) => ({
    default: module.AppliesLobby,
  })),
);
export const IframeMedicalReferrals = lazy(() =>
  import('Modules/MedicalReferrals').then((module) => ({
    default: module.MedicalReferrals,
  })),
);
export const Equipment = lazy(() =>
  import('Modules/Equipment').then((module) => ({ default: module.Equipment })),
);
export const EquipmentCreateOrder = lazy(() =>
  import('Modules/EquipmentCreateOrder').then((module) => ({
    default: module.EquipmentCreateOrder,
  })),
);
export const EquipmentOrderInfo = lazy(() =>
  import('Modules/EquipmentOrderInfo').then((module) => ({
    default: module.EquipmentOrderInfo,
  })),
);
export const TestLinks = lazy(() =>
  import('Modules/TestLinks').then((module) => ({ default: module.TestLinks })),
);
export const EshetTursRedirect = lazy(() =>
  import('Modules/EshetTursRedirect').then((module) => ({
    default: module.EshetTursRedirect,
  })),
);
export const TestImages = lazy(() =>
  import('Modules/TestImages').then((module) => ({
    default: module.TestImages,
  })),
);
export const FlyingCarpetRedirect = lazy(() =>
  import('Modules/FlyingCarpetRedirect').then((module) => ({
    default: module.FlyingCarpetRedirect,
  })),
);
export const FormsDetails = lazy(() =>
  import('Modules/FormsDetails').then((module) => ({
    default: module.FormsDetails,
  })),
);
export const Requests = lazy(() =>
  import('Modules/Requests').then((module) => ({ default: module.Requests })),
);
export const Confirmations = lazy(() =>
  import('Modules/Confirmations').then((module) => ({
    default: module.Confirmations,
  })),
);
export const PersonalDetails = lazy(() =>
  import('Modules/PersonalDetails').then((module) => ({
    default: module.PersonalDetails,
  })),
);
export const PersonalTeam = lazy(() =>
  import('Modules/PersonalTeam').then((module) => ({
    default: module.PersonalTeam,
  })),
);
export const CompassRights = lazy(() =>
  import('Modules/CompassRights').then((module) => ({
    default: module.CompassRights,
  })),
);
export const CompassRightsEntitlement = lazy(() =>
  import('Modules/CompassRightsEntitlement').then((module) => ({
    default: module.CompassRightsEntitlement,
  })),
);
export const MedicalReferrals = lazy(() =>
  import('Modules/MedicalReferrals').then((module) => ({
    default: module.MedicalReferrals,
  })),
);
export const DisabledVeteran = lazy(() =>
  import('Modules/DisabledVeteran').then((module) => ({
    default: module.DisabledVeteran,
  })),
);
export const Treatment = lazy(() =>
  import('Modules/Treatment').then((module) => ({ default: module.Treatment })),
);
export const PaymentsAndDeductions = lazy(() =>
  import('Modules/PaymentsAndDeductions').then((module) => ({
    default: module.PaymentsAndDeductions,
  })),
);
export const IframePaymentsAndDeductions = lazy(() =>
  import('Modules/PaymentsAndDeductions').then((module) => ({
    default: module.PaymentsAndDeductions,
  })),
);
export const Documents = lazy(() =>
  import('Modules/Documents').then((module) => ({ default: module.Documents })),
);
export const DocumentsOld = lazy(() =>
  import('Modules/DocumentsOld').then((module) => ({
    default: module.DocumentsOld,
  })),
);
export const Updates = lazy(() =>
  import('Modules/Updates').then((module) => ({ default: module.Updates })),
);
export const UniversalRequest = lazy(() =>
  import('Modules/UniversalRequest').then((module) => ({
    default: module.UniversalRequest,
  })),
);
export const OTPLogin = lazy(() =>
  import('Modules/OTPLogin').then((module) => ({ default: module.OTPLogin })),
);
export const Error = lazy(() =>
  import('Modules/Error').then((module) => ({ default: module.Error })),
);
export const DisabilityConfirmations = lazy(() =>
  import('Modules/DisabilityApprovals').then((module) => ({
    default: module.DisabilityConfirmations,
  })),
);
export const Suppliers = lazy(() =>
  import('Modules/Suppliers').then((module) => ({ default: module.Suppliers })),
);
export const SingleSupplier = lazy(() =>
  import('Modules/SingleSupplier').then((module) => ({
    default: module.SingleSupplier,
  })),
);
export const LongtermEquipment = lazy(() =>
  import('Modules/LongtermEquipment').then((module) => ({
    default: module.LongtermEquipment,
  })),
);
export const IframeLongtermEquipment = lazy(() =>
  import('Modules/LongtermEquipment').then((module) => ({
    default: module.LongtermEquipment,
  })),
);
export const B2CFirstLoginLanding = lazy(() =>
  import('Modules/B2C').then((module) => ({
    default: module.B2CFirstLoginLanding,
  })),
);
export const Reimbursements = lazy(() =>
  import('Modules/Reimbursements').then((module) => ({
    default: module.Reimbursements,
  })),
);
export const Cannabis = lazy(() =>
  import('Modules/Reimbursements/Cannabis').then((module) => ({
    default: module.Cannabis,
  })),
);
export const AlternativeMedicine = lazy(() =>
  import('Modules/Reimbursements/AlternativeMedicine').then((module) => ({
    default: module.AlternativeMedicine,
  })),
);
export const FamilyMembers = lazy(() =>
  import('Modules/Reimbursements/FamilyMembers').then((module) => ({
    default: module.FamilyMembers,
  })),
);
export const LawyersLobby = lazy(() =>
  import('Modules/LawyersLobby').then((module) => ({
    default: module.LawyersLobby,
  })),
);
export const SearchResults = lazy(() =>
  import('Modules/SearchResults').then((module) => ({
    default: module.SearchResults,
  })),
);
export const B2CError = lazy(() =>
  import('Components/B2CError').then((module) => ({
    default: module.B2CError,
  })),
);
export const AuthLoader = lazy(() =>
  import('Modules/AuthLoader').then((module) => ({
    default: module.AuthLoader,
  })),
);
export const DataAnalysisLobby = lazy(() =>
  import('Modules/DataAnalysis/Lobby').then((module) => ({
    default: module.DataAnalysis,
  })),
);
export const DataAnalysisPromptManager = lazy(() =>
  import('Modules/DataAnalysis/PromptManager').then((module) => ({
    default: module.PromptManager,
  })),
);
export const AdminSelfReferralGeneratedList = lazy(() =>
  import('Modules/AdminSelfReferralGeneratedList').then((module) => ({
    default: module.AdminSelfReferralGeneratedList,
  })),
);
export const AdminSelfReferralDebug = lazy(() =>
  import('Modules/AdminSelfReferralDebug').then((module) => ({
    default: module.AdminSelfReferralDebug,
  })),
);
export const AdminLogs = lazy(() =>
  import('Modules/AdminLogs').then((module) => ({
    default: module.AdminLogs,
  })),
);

// Medical Committees
export const Lobby = lazy(() =>
  import('Modules/MedicalCommittees/Lobby').then((module) => ({
    default: module.Lobby,
  })),
);
export const Committee = lazy(() =>
  import('Modules/MedicalCommittees/Committee').then((module) => ({
    default: module.Committee,
  })),
);
export const AddContactForm = lazy(() =>
  import('Modules/MedicalCommittees/AddContactForm').then((module) => ({
    default: module.AddContactForm,
  })),
);
export const ContactSuccess = lazy(() =>
  import('Modules/MedicalCommittees/ContactSuccess/ContactSuccess').then(
    (module) => ({
      default: module.ContactSuccess,
    }),
  ),
);
export const CompletedCommittees = lazy(() =>
  import('Modules/MedicalCommittees/CompletedCommittees').then((module) => ({
    default: module.CompletedCommittees,
  })),
);

export const RecordingsLobby = lazy(() =>
  import('Modules/MedicalCommittees/RecordingsLobby').then((module) => ({
    default: module.RecordingsLobby,
  })),
);
export const FeedbackAdmin = lazy(() =>
  import('Modules/FeedbackAdmin').then((module) => ({
    default: module.FeedbackAdmin,
  })),
);
export const MaintenancePage = lazy(() =>
  import('Modules/MaintenancePage').then((module) => ({
    default: module.MaintenancePage,
  })),
);
export const EmergencyCall = lazy(() =>
  import('Modules/EmergencyCall').then((module) => ({
    default: module.EmergencyCall,
  })),
);
export const AdminEmergencyCall = lazy(() =>
  import('Modules/AdminEmergencyCall').then((module) => ({
    default: module.AdminEmergencyCall,
  })),
);
export const AdminEmergencyCallAgents = lazy(() =>
  import('Modules/AdminEmergencyCall/Agents').then((module) => ({
    default: module.Agents,
  })),
);
export const EmergencyCallLogin = lazy(() =>
  import('Modules/EmergencyCall/OTPLogin').then((module) => ({
    default: module.OTPLogin,
  })),
);
export const MedicalCar = lazy(() =>
  import('Modules/MedicalCar').then((module) => ({
    default: module.MedicalCar,
  })),
);
export const DisabilityCalculator = lazy(() =>
  import('Modules/DisabilityCalculator').then((module) => ({
    default: module.DisabilityCalculator,
  })),
);
export const RecognitionDashboard = lazy(() =>
  import('Modules/RecognitionDashboard').then((module) => ({
    default: module.RecognitionDashboard,
  })),
);
export const SelfReferralClaimToPgima = lazy(() =>
  import('Modules/SelfReferral/ClaimToPgima').then((module) => ({
    default: module.ClaimToPgima,
  })),
);
export const SelfReferralSectorToSimulPgima = lazy(() =>
  import('Modules/SelfReferral/SectorToSimulPgima').then((module) => ({
    default: module.SectorToSimulPgima,
  })),
);
export const SelfServiceReferrals = lazy(() =>
  import('Modules/SelfServiceReferrals').then((module) => ({
    default: module.SelfServiceReferrals,
  })),
);
